import { render, staticRenderFns } from "./electronicContract.vue?vue&type=template&id=64766da3&scoped=true"
import script from "./electronicContract.vue?vue&type=script&lang=js"
export * from "./electronicContract.vue?vue&type=script&lang=js"
import style0 from "./electronicContract.vue?vue&type=style&index=0&id=64766da3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64766da3",
  null
  
)

export default component.exports